<template>
  <v-hover>
    <template v-slot:default="{ hover }">
      <v-card outlined :elevation="hover ? 6 : 0" class="transition-swing">
        <div class="cardContent" @click="cardClicked">
          <v-img
            contain
            :src="product.images[0].imageSrc"
            :lazy-src="product.images[0].imageSml"
            height="240px"
          />
          <v-card-title>{{ product.title }} <v-chip color="orange" style="margin-left: 10px; padding: 10px" v-if="product.new">NEU</v-chip></v-card-title>
          <v-card-subtitle
            ><div style="min-height:65px">
              {{ product.description }}
            </div></v-card-subtitle
          >
        </div>
        <v-card-actions class="pt-0">
          <v-card-text>
            <span class="font-weight-bold"
              >{{ product.price.toFixed(2).replace(".", ",") }} €</span
            >
            <span class="body-2" style="color: rgba(0, 0, 0, 0.6)">
              ({{ product.size }}{{ product.sizeUnit }})</span
            >
          </v-card-text>

          <v-spacer></v-spacer>
          <v-btn
            class="ma-2"
            :loading="loadingCart"
            :disabled="loadingCart"
            color="greenb"
            @click="shopProduct()"
          >
            <v-icon color="white">mdi-cart</v-icon>
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon color="greend">mdi-cart-check</v-icon>
              </span>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-hover>
</template>

<script>
export default {
  data() {
    return {
      loader: null,
      loadingCart: false
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 1000);
      this.loader = null;
    }
  },
  props: {
    product: Object,
    addToCart: Function
  },
  methods: {
    cardClicked() {
      this.$ga.event("Navigation", this.product.title + " im Shop geklickt", this.product.title +" im Shop");
      this.$router.push({
        name: "Product",
        params: { productTitle: this.product.title }
      });
    },
    shopProduct() {
      this.$ga.event("Cart", this.product.title + " 1x in Warenkorb gelegt (Shop-Übersicht)");
      this.loader = "loadingCart";
      this.addToCart(this.product);
    }
  }
};
</script>

<style scoped>
.cardContent:hover {
  cursor: pointer;
}
</style>
